export default "__VITE_ASSET__eb98359d__"